import { forwardRef } from 'react'
import { Link, LinkProps } from 'react-router'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
export type AnchorProps = LinkProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export interface ButtonComponentProps
  extends Partial<ButtonProps & AnchorProps> {
  to?: string;
  size?: 'small' | 'medium' | 'large';
  theme?: 'primary' | 'secondary' | 'grey' | 'white' | 'quaternary';
}

const Button = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonComponentProps
>(
  (
    { to, children, className, theme = 'primary', size = 'medium', ...props },
    ref,
  ) => {
    if (to) {
      return (
        <Link
          to={to}
          ref={ref as React.Ref<HTMLAnchorElement>}
          className={cn(styles.root, className, styles[theme], styles[size])}
          {...props}
        >
          {children}
        </Link>
      )
    }

    return (
      <button
        type="button"
        ref={ref as React.Ref<HTMLButtonElement>}
        className={cn(
          'reset-button',
          styles.root,
          className,
          styles[theme],
          styles[size],
        )}
        {...props}
      >
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'

export default Button
